// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"static-React-HVJS-HVUI-Errors-___ErrorMessage-module__ErrorMessage","ErrorIconContainer":"static-React-HVJS-HVUI-Errors-___ErrorMessage-module__ErrorIconContainer"};